export const LOADING_FORMTYPES = "LOADING_FORMTYPES";
export const GET_FORMTYPES_SUCCESS = "GET_FORMTYPES_SUCCESS";
export const GET_FORMTYPES_FAILURE = "GET_FORMTYPES_FAILURE";
export const RESET_FORMTYPES = "RESET_FORMTYPES";
